var render, staticRenderFns
import script from "./JJIcons.vue?vue&type=script&setup=true&lang=tsx&"
export * from "./JJIcons.vue?vue&type=script&setup=true&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports